import { api } from "constants/RotasAPI";
import usePost from "hooks/usePost";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { RequestNewPassword } from "types/request/RequestNewPassword";

export const usePostResetPassword = () => {
  const navigate = useNavigate();

  const onSuccess = (response: object, request: RequestNewPassword) => {
    toast.success("Senha alterada com sucesso.");
    navigate("/v2/login", { replace: true });
  };

  const onError = () => {
    toast.error("Erro ao alterar senha.");
  };

  return usePost<RequestNewPassword>({
    url: api.usuario.postConfirmarSenha,
    onSuccess,
    onError,
  });
};
